import axios from "axios";

import { authTokenRequestInterceptor } from "./interceptors";
import { tokenRequestInterceptor } from "./interceptorsBff";

export const getBaseAxiosInstance = (
  baseURL: string,
  opts: { isBff?: boolean } = {},
) => {
  const api = axios.create({ baseURL });

  api.interceptors.request.use(authTokenRequestInterceptor);
  if (opts?.isBff) {
    api.interceptors.request.use(tokenRequestInterceptor);
  }

  return api;
};
